import { FormSelectYesNo } from '../../formelements'


export const AuthAlcohol = ({ auth, handleChange, error }) => {

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Autorització tast de begudes alchohòliques:
                </h4>
                <p>
                    Dins dels estudis s'inclou el coneixement de les característiques del vi realitzant, a vegades, pràctiques de tast. El tast del vi implica tastar-lo en una
                    quantitat molt petita, solament per apreciar-ne les qualitats organolèptiques.
                </p>
                        <FormSelectYesNo
                            id="authAlcohol"
                            name="authAlcohol"
                            col="col-6"
                            label="Trieu una opció:"
                            obligatori={true}
                            value={auth}
                            handleChange={(e) => handleChange(e.target.value) } 
                            error={error}
                            />
                <br />

            </div>
        </div>

        <br />
    </>)

}